<h2 mat-dialog-title>Potvrda akcije</h2>
<mat-dialog-content>
  Da li ste sigurni da želite da nastavite sa ovom akcijom?
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button (click)="closeDialog(false)">Ne</button>
  <span class="flex-spacer"></span>
  <button mat-flat-button color="warn" (click)="closeDialog(true)">Da</button>
</mat-dialog-actions>
